// extracted by mini-css-extract-plugin
export default {"range":"vqtYZ","from":"G2DxH","to":"oPaJ3","fromInModal":"ODZfw","toInModal":"gkREO","delimiter":"f7uex"};